import React from "react";
import { Zap, Layout, Globe, Award, TrendingUp, ThumbsUp } from "lucide-react";
import "../styles/aiToolsInfo.css";

export default function AIToolsInfo() {
  const features = [
    {
      icon: <Zap className="info-icon purple" />,
      title: "Updated Daily",
      desc: "If you’re interested in AI, you know how difficult it can be to find the best AIs in each category. We list and rank the best AI tools across roughly 50 growing categories with patience and rigor."
    },
    {
      icon: <Layout className="info-icon pink" />,
      title: "Clear, Simple & Ergonomic",
      desc: "Easily see which AIs are trending. Each tool features mouse-over details, quick navigation, and clear pricing tags (Free, Freemium, Paid) alongside immediate search filtering."
    },
    {
      icon: <Globe className="info-icon blue" />,
      title: "Available Worldwide",
      desc: "Completely free of charge, listing extensive AI models. Accessible everywhere and fully adaptive to all screen sizes: mobile, tablet, desktop, or projector."
    },
    {
      icon: <TrendingUp className="info-icon magenta" />,
      title: "Constantly Changing Top 10",
      desc: "The community moves fast, and so do our leaderboards. A sudden burst of popularity can propel tools into the ultimate top positions over a single night."
    },
    {
      icon: <Award className="info-icon orange" />,
      title: "The Ultimate AI Ranking",
      desc: "Our unique sorting algorithm relies directly on user engagement, view counts, and continuous evaluations to give you a genuine outlook on software performance."
    },
    {
      icon: <ThumbsUp className="info-icon indigo" />,
      title: "Vote For Your Favorites",
      desc: "Your opinion is precious! Help guide enthusiasts. Upvote, save, and aggregate the tools that truly maximize your personal productivity daily."
    }
  ];

  return (
    <section className="ai-info-section">
      <div className="info-header">
        <span className="info-badge">Why Choose VBlogAI?</span>
        <h2>Explore the Fascinating World of <span>Artificial Intelligence</span></h2>
        <p>Finding the perfect companion for your digital workflow just got ten times simpler.</p>
      </div>

      <div className="info-grid">
        {features.map((item, idx) => (
          <div key={idx} className="info-card">
            <div className="info-icon-wrapper">
              {item.icon}
            </div>
            <h3>{item.title}</h3>
            <p>{item.desc}</p>
          </div>
        ))}
      </div>

      <div className="info-cta">
        <div className="cta-content">
          <h3>Ready to elevate your intelligence?</h3>
          <p>Join thousands of builders curating incredible AI workflows safely.</p>
          <button className="cta-btn" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>
            Back To Search
          </button>
        </div>
      </div>
    </section>
  );
}
